import { render, staticRenderFns } from "./IdentifyWaitingForProvider.vue?vue&type=template&id=4438525a&scoped=true&"
import script from "./IdentifyWaitingForProvider.vue?vue&type=script&lang=ts&"
export * from "./IdentifyWaitingForProvider.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyWaitingForProvider.vue?vue&type=style&index=0&id=4438525a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438525a",
  null
  
)

export default component.exports